module.exports = __webpack_public_path__ + "static/img/no2.2e9ae11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/no2.png
// module id = BgFA
// module chunks = 1